/**
 * RoleCheckboxList — multi-select role checkboxes shared by the Add User and
 * Edit Role dialogs. Extracted from `routes/admin/users/index.tsx` (issue
 * #1411).
 */
import { ALL_ROLES, getRoleLabel } from '../../types/users';
import type { UserRole } from '../../types/users';

export interface RoleCheckboxListProps {
  selected: UserRole[];
  onChange: (roles: UserRole[]) => void;
  idPrefix: string;
}

export function RoleCheckboxList({
  selected,
  onChange,
  idPrefix,
}: RoleCheckboxListProps): JSX.Element {
  const toggle = (role: UserRole): void => {
    if (selected.includes(role)) {
      onChange(selected.filter((r) => r !== role));
    } else {
      onChange([...selected, role]);
    }
  };

  return (
    <div className="users-role-checkboxes" data-testid="role-checkbox-list">
      {ALL_ROLES.map((role) => (
        <label key={role} className="users-role-checkbox-label" htmlFor={`${idPrefix}-${role}`}>
          <input
            id={`${idPrefix}-${role}`}
            type="checkbox"
            checked={selected.includes(role)}
            onChange={() => toggle(role)}
            data-testid={`role-checkbox-${role}`}
          />
          {getRoleLabel(role)}
        </label>
      ))}
    </div>
  );
}
